package com.schoolconnect.app.repository.common

import com.schoolconnect.app.datasource.network.UserSessionStore

/** Stable cache namespace for data that must not survive an account/assignment context change. */
fun tenantCacheKey(scope: String): String {
    val userId = UserSessionStore.getUserId().trim().ifBlank { "anonymous" }
    val assignmentId = UserSessionStore.getActiveAssignmentId().trim().ifBlank { "unassigned" }
    val normalizedScope = scope.trim().ifBlank { "default" }
    return "$userId|$assignmentId|$normalizedScope"
}
